import { createApiActions } from '@shared/ngrx-factory/factory.actions';
import { ListAgentsByCompanyRequest } from '../requests/shipping-agent-management.request';
import {
  ShippingAgentDetails,
  ShippingAgentItem,
  ShippingAgentManagementResponse,
  ShippingAgentPageableResponse,
} from '../responses/shipping-agent-management.response';

export interface RequestState<T> {
  loading: boolean;
  message: string | null;
  response: T | null;
  error: T | null;
}

export interface ShippingAgentManagementState {
  myApplications: RequestState<
    ShippingAgentManagementResponse<ShippingAgentPageableResponse<ShippingAgentItem>>
  >;
  agentRegistrationDetails: RequestState<
    ShippingAgentManagementResponse<ShippingAgentDetails>
  >;
}

export const ListAgentsByCompanyActions = createApiActions<
  ListAgentsByCompanyRequest,
  ShippingAgentManagementResponse<ShippingAgentPageableResponse<ShippingAgentItem>>
>('Shipping Agent Management', 'List Agents By Company');

export const GetAgentRegistrationActions = createApiActions<
  string,
  ShippingAgentManagementResponse<ShippingAgentDetails>
>('Shipping Agent Management', 'Get Agent Registration');
